<template>
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-0 -z-10 overflow-hidden"
  >
    <div
      :class="originClass"
      class="absolute inset-0 [mask-image:radial-gradient(120%_100%_at_var(--field-origin,0%)_0%,#000_10%,transparent_70%)]"
    >
      <div
        :class="trameClass"
        class="absolute inset-0 bg-[length:3rem_3rem]"
      />

      <!-- Same trame used as a mask: the travelling band can only paint the 1px lines, never the surface between them -->
      <div class="absolute inset-0 [mask-image:linear-gradient(to_right,#000_1px,transparent_1px),linear-gradient(to_bottom,#000_1px,transparent_1px)] [mask-size:3rem_3rem]">
        <div
          :class="bandClass"
          class="absolute inset-x-0 top-[-40%] h-[40%] bg-gradient-to-b from-transparent to-transparent animate-sweep motion-reduce:animate-none"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  origin?: 'left'|'right'|'center',
  inverted?: boolean
}

const { origin = 'left', inverted = false } = defineProps<Props>()

const originClass = computed<string>(() => {
  if (origin === 'right') return '[--field-origin:100%]'
  if (origin === 'center') return '[--field-origin:50%]'

  return '[--field-origin:0%]'
})

const trameClass = computed<string>(() => {
  return inverted ? 'bg-grid-field-invert' : 'bg-grid-field'
})

// Light ground: the soft decorative red of the badge ring. Dark ground: the red the box illustration lights up with.
const bandClass = computed<string>(() => {
  return inverted ? 'via-brand-500' : 'via-brand-200'
})
</script>
